export interface IFliTotalRow {
    accountName: string;
    currentValue: number;
    previousValue: number;
}
